import React from "react";
import { dataFormato } from '../utils/dateFormato';

function PagamentosTab({ pagamentos, money, handleEditPayment }) {
  return (
    <div className="tab-pane fade" id="quarta-aba" role="tabpanel">
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-bordered mt-10">
          <thead>
            <tr>
              <th>Status</th>
              <th>Download</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Data de Pagamento</th>
              <th>Informações</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {pagamentos.map((pagamento) => (
              <tr key={pagamento.id}>
                <td>
                  <i
                    className={`fas fa-money-bill-wave bg-${pagamento.status.toLowerCase()} center-element`}
                    title={`${pagamento.status}`}
                    id="money"
                  ></i>{" "}
                </td>
                <td>
                  <a
                    style={{ color: "green" }}
                    href={`https://guias.almeidaenogueira.com.br/api/download/pagamento/${pagamento.id}`}
                  >
                    <i className="fa fa-cloud-download mr-3" />
                    {pagamento.anexo}
                  </a>
                </td>
                <td>{pagamento.tipo}</td>
                <td>{pagamento.descricao}</td>
                <td>{pagamento.valor}</td>
                <td>{dataFormato(pagamento.data_pagamento)}</td>
                <td>{pagamento.informacoes}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-success"
                    title="Upload do comprovante"
                    onClick={() => handleEditPayment(pagamento.id)}
                  >
                    <i className="fas fa-file-upload"></i>
                  </button>{" "}
                </td>
              </tr>
            ))}
            <tr>
              <th>Total</th>
              <th colSpan="3"></th>
              <th>{money()}</th>
              <th colSpan="3"></th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PagamentosTab;
